import api from '../utils/api';

export const getSentAll = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/messagelog/getSentAll`,
        method: "POST",
        data: data,
        ...options,
    });
}